var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventTypeEvent01 = function SvgEventTypeEvent01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "event_type_event-01_svg2__a",
    x1: 21.04,
    x2: 176.8,
    y1: 175.27,
    y2: 39.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_event-01_svg2__a",
    id: "event_type_event-01_svg2__b",
    x1: -9.38,
    x2: 146.38,
    y1: 140.25,
    y2: 4.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_event-01_svg2__a",
    id: "event_type_event-01_svg2__c",
    x1: 12.79,
    x2: 168.55,
    y1: 165.77,
    y2: 30.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_event-01_svg2__a",
    id: "event_type_event-01_svg2__d",
    x1: 29.29,
    x2: 185.06,
    y1: 184.76,
    y2: 49.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_event-01_svg2__a",
    id: "event_type_event-01_svg2__e",
    x1: 24.64,
    x2: 180.4,
    y1: 179.41,
    y2: 44.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#event_type_event-01_svg2__a",
    id: "event_type_event-01_svg2__f",
    x1: 45.79,
    x2: 201.56,
    y1: 203.76,
    y2: 68.42
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.66 36.67h-42.28L116.95 9.31C110.99-.05 98.58-2.81 89.22 3.14a20.2 20.2 0 0 0-6.17 6.17L65.62 36.67H23.34C10.46 36.68.02 47.12 0 60v93.33c.02 12.88 10.45 23.32 23.33 23.33h47.23c.91 0 1.78.37 2.41 1.03l19.95 19.35c3.83 3.91 10.11 3.96 14.01.13l.08-.08 20.04-19.43c.63-.64 1.48-1 2.38-1h47.23c12.88-.02 23.32-10.45 23.33-23.33V60c-.02-12.88-10.45-23.32-23.33-23.33M88.67 12.89c3.97-6.25 12.26-8.1 18.51-4.13a13.6 13.6 0 0 1 4.13 4.13l46.53 73.03c4.01 6.28 2.18 14.61-4.1 18.63a13.43 13.43 0 0 1-7.21 2.12H53.47c-7.45-.02-13.47-6.07-13.46-13.52 0-2.56.74-5.07 2.12-7.23zm104.66 140.44c-.01 9.2-7.47 16.65-16.67 16.67h-47.23c-2.64 0-5.18 1.04-7.05 2.91l-20.05 19.45a3.29 3.29 0 0 1-4.66 0l-.05-.05-19.96-19.36a9.95 9.95 0 0 0-7.1-2.94H23.34c-9.2-.01-16.65-7.47-16.67-16.67V60c.01-9.2 7.47-16.65 16.67-16.67h38.04l-24.85 39c-5.99 9.38-3.24 21.84 6.15 27.83 3.23 2.06 6.97 3.16 10.8 3.16h93.06c11.13-.02 20.14-9.07 20.11-20.2 0-3.83-1.11-7.57-3.16-10.8l-24.85-39h38.04c9.2.01 16.65 7.47 16.67 16.67v93.33Z",
    style: {
      fill: "url(#event_type_event-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 73.33c10.45 0 13.33-39.6 13.33-40 0-7.36-5.97-13.33-13.33-13.33s-13.33 5.97-13.33 13.33c0 .4 2.89 40 13.33 40m0-46.66c3.68 0 6.67 2.98 6.67 6.67 0 5.77-3.5 26.74-6.67 32.41-3.16-5.67-6.67-26.64-6.67-32.41 0-3.68 2.98-6.67 6.67-6.67",
    style: {
      fill: "url(#event_type_event-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 80c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#event_type_event-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66 119.99H53.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h93.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      fill: "url(#event_type_event-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.34 143.33h33.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H53.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#event_type_event-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66 153.33H53.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h93.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      fill: "url(#event_type_event-01_svg2__f)"
    }
  }));
};
export default SvgEventTypeEvent01;